"use client";

import classNames from "@casino/external/classNames";
import BitcasinoLoad from "@casino/external/icons/original_games/BitcasinoLoad";
import SportsbetLoad from "@casino/external/icons/original_games/SportsbetLoad";
import type { FC } from "react";

type Props = {
  isHidden?: boolean;
  site?: Site;
};

const WebComponentGameLoader: FC<Props> = ({ isHidden, site }) => (
  <div
    data-testid="hub88-loader"
    className={classNames(
      "absolute inset-0 flex h-full w-full items-center justify-center pointer-events-none",
      isHidden ? "invisible" : "visible",
    )}
  >
    {site === "sportsbet" ? <SportsbetLoad /> : <BitcasinoLoad />}
  </div>
);

export default WebComponentGameLoader;
